import { ROLES } from './constants';

export const AGREEMENT_ADMIN_TYPES = [
  { type: 'nda', label: 'NDA' },
  { type: 'beta', label: 'Beta Tester Agreement' },
];

export function canAccessAgreementsAdmin(role) {
  return role === ROLES.ADMIN || role === ROLES.SUPERADMIN;
}

export function isTestAgreement(version) {
  if (!version) return false;
  const haystack = [version.title, version.body, version.version]
    .filter(Boolean)
    .join(' ')
    .toUpperCase();
  return haystack.includes('TEST') || haystack.includes('NOT LEGAL');
}

export function formatAgreementDate(value) {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleString();
}

export function sortVersionsNewestFirst(versions) {
  return [...(versions || [])].sort((a, b) => {
    const left = a.publishedAt || a.createdAt || '';
    const right = b.publishedAt || b.createdAt || '';
    return right.localeCompare(left);
  });
}

export function withCurrentFlags(versions) {
  const sorted = sortVersionsNewestFirst(versions);
  return sorted.map((item, index) => ({
    ...item,
    isCurrent: index === 0,
    historyLabel: index === 0 ? 'current' : 'previous',
  }));
}

export function currentPublishedVersion(versions) {
  return withCurrentFlags(versions)[0] || null;
}

export function validateAgreementDraft({ title, version, body }) {
  const errors = {};
  if (!String(title || '').trim()) errors.title = 'Title is required';
  if (!String(version || '').trim()) errors.version = 'Version is required';
  if (!String(body || '').trim()) errors.body = 'Agreement body is required';
  return {
    valid: Object.keys(errors).length === 0,
    errors,
  };
}
